import { useCallback } from "react"
import { subscriptionService } from "../../../data/services/subscriptionService"
import { apiError } from "../newSubscriptionUtils"

/**
 * « Utiliser ma carte » : le serveur réserve la vente sur la carte enregistrée ;
 * si la banque demande 3-D Secure, Stripe.js fait valider le parent puis le
 * serveur relit l'intention et honore la vente. Rend `{ error }` en cas d'échec.
 */
export const useSavedCardReservation = ({ stripePromise, email, sale }) =>
    useCallback(async () => {
        try {
            const reserved = (
                await subscriptionService.reserveWithSavedCard(
                    {},
                    { email, sale }
                )
            ).data?.data

            if (reserved?.status === "requires_action") {
                const stripe = await stripePromise
                const { error } = await stripe.handleNextAction({
                    clientSecret: reserved.client_secret,
                })
                if (error) return { error: error.message }

                await subscriptionService.confirmSavedCardReservation(
                    {},
                    { email, sale, intent_id: reserved.intent_id }
                )
            }

            return { error: null }
        } catch (err) {
            return { error: apiError(err) }
        }
    }, [stripePromise, email, sale])
